export default "__VITE_ASSET__FufJhA0x__"